import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from '../../App.js';

export default function Navbar() {

    const navigate = useNavigate();
    const { setAuthenticationToken } = useContext(AuthenticationContext);

    function handleAdminLogoutClick() {
        setAuthenticationToken(null);
        localStorage.removeItem("adminAuthenticationToken");
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container">
                    <a className="navbar-brand" href="/" onClick={(ev) => { ev.preventDefault(); navigate("/") }}>
                        SIHE - Area amministrativa
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="!#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Aziende</a>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="/aziendebuyer" onClick={(ev) => { ev.preventDefault(); navigate("/aziendebuyer") } }>Aziende buyer</a></li>
                                    <li><a className="dropdown-item" href="/aziendeseller" onClick={(ev) => { ev.preventDefault(); navigate("/aziendeseller") } }>Aziende seller</a></li>
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="!#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Impostazioni</a>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="/date" onClick={(ev) => { ev.preventDefault(); navigate("/date") }}>Date</a></li>
                                    <li><a className="dropdown-item" href="/dateore" onClick={(ev) => { ev.preventDefault(); navigate("/dateore") }}>Date/Ore</a></li>
                                    <li><a className="dropdown-item" href="/impostazioni" onClick={(ev) => { ev.preventDefault(); navigate("/impostazioni") }}>Impostazioni generali</a></li>
                                    <li><a className="dropdown-item" href="/macroregioni" onClick={(ev) => { ev.preventDefault(); navigate("/macroregioni") }}>Macroregioni</a></li>
                                    <li><a className="dropdown-item" href="/tipologieaziendebuyer" onClick={(ev) => { ev.preventDefault(); navigate("/tipologieaziendebuyer") }}>Tipologie buyer</a></li>
                                    <li><a className="dropdown-item" href="/tipologieaziendeseller" onClick={(ev) => { ev.preventDefault(); navigate("/tipologieaziendeseller") }}>Tipologie seller</a></li>
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="!#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Appuntamenti</a>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="/riepilogoappuntamentibuyer" onClick={(ev) => { ev.preventDefault(); navigate("/riepilogoappuntamentibuyer") }}>Riepilogo appuntamenti buyer</a></li>
                                    <li><a className="dropdown-item" href="/riepilogoappuntamentiseller" onClick={(ev) => { ev.preventDefault(); navigate("/riepilogoappuntamentiseller") }}>Riepilogo appuntamenti seller</a></li>
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="!#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Stampe</a>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="/stampaagendebuyer" target="_blank">Stampa agende buyer</a></li>
                                    <li><a className="dropdown-item" href="/stampaagendeseller" target="_blank">Stampa agende seller</a></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <button type="button" className="btn btn-link" onClick={handleAdminLogoutClick} style={{ textDecoration: "none", color: "inherit" }}>Logout</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        </>
    );
}
